import SendProgress from "./SendProgress";
import { AlertTriangle, Check } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

export default function SendFeedbackDialog({ state = "idle", channel = "E-Mail", detail = "", error = "", onClose }) {
  const sending = state === "sending";
  const label = channel === "Instagram" ? "Instagram-Nachricht" : channel || "E-Mail";

  return (
    <Dialog open={state !== "idle"} onOpenChange={(open) => { if (!open && !sending) onClose?.(); }}>
      <DialogContent
        className="sm:max-w-sm rounded-2xl"
        hideClose={sending}
        autoLoading={false}
        onEscapeKeyDown={(event) => { if (sending) event.preventDefault(); }}
        onPointerDownOutside={(event) => { if (sending) event.preventDefault(); }}
      >
        <DialogHeader><DialogTitle className="sr-only">{label}-Versand</DialogTitle><DialogDescription className="sr-only">{detail || `Status des ${label}-Versands.`}</DialogDescription></DialogHeader>
        <SendFeedbackContent state={state} channel={channel} detail={detail} error={error} onClose={onClose}/>
      </DialogContent>
    </Dialog>
  );
}

export function SendFeedbackContent({state, channel="E-Mail", detail="", error="", errorTitle="Versand fehlgeschlagen", errorCloseLabel="Schließen", onClose}) {
  const sending = state === "sending";
  const label = channel === "Instagram" ? "Instagram-Nachricht" : channel || "E-Mail";
  return (        <div className="flex flex-col items-center px-2 py-4 text-center" role={sending ? undefined : "status"} aria-live="polite" data-send-feedback>
          {sending && (
            <>
              <SendProgress label={label} detail={detail} />
            </>
          )}
          {state === "success" && (
            <>
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#34C759]/12 animate-in zoom-in-50 duration-300">
                <Check className="h-8 w-8 text-[#34C759]" strokeWidth={3} aria-hidden="true" />
              </div>
              <p className="mt-5 text-base font-semibold text-[#1D1D1F]">{label} gesendet</p>
              {detail ? <p className="mt-1 text-sm text-[#86868B]">{detail}</p> : null}
              <Button type="button" className="btn-primary mt-6 w-full" onClick={onClose}>Fertig</Button>
            </>
          )}
          {state === "error" && (
            <>
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FF3B30]/12">
                <AlertTriangle className="h-8 w-8 text-[#FF3B30]" aria-hidden="true" />
              </div>
              <p className="mt-5 text-base font-semibold text-[#1D1D1F]">{errorTitle}</p>
              {error ? <p className="mt-3 w-full rounded-xl bg-[#F5F5F7] px-4 py-3 text-left text-sm text-[#1D1D1F]">{error}</p> : null}
              <Button type="button" variant="outline" className="mt-6 w-full" onClick={onClose}>{errorCloseLabel}</Button>
            </>
          )}
        </div>
  );
}
